import { localDatasource } from '@localStorage/infra/datasource/LocalDatasource'

import WrongDataError from '@/modules/localStorage/domain/exceptions/wrongDataError'

const withLocalStorageKeyPrefix = (key: string) => `ea-${key}`

export const localStorageDatasource: localDatasource = {
  get<Data>(key: string): Data | null {
    const item = localStorage.getItem(withLocalStorageKeyPrefix(key))
    if (!item) return null

    try {
      const data = JSON.parse(item) as Data
      return data
    } catch (err) {
      if (err instanceof SyntaxError)
        throw new WrongDataError({
          message: 'Local storage data is not a valid JSON.',
          action: 'Fix it or Remove it completly.',
          cause: err
        })
      else throw err
    }
  },

  store<Data>(key: string, data: Data): void {
    const item = JSON.stringify(data)
    localStorage.setItem(withLocalStorageKeyPrefix(key), item)
  },

  delete(key: string): void {
    localStorage.removeItem(withLocalStorageKeyPrefix(key))
  },

  clear() {
    localStorage.clear()
  }
}
